export const WEBSITE_LINK = "https://www.klim.eco";
export const IMPRINT_LINK = "https://www.klim.eco/imprint";
export const CODE_OF_CONDUCT_LINK = "https://www.klim.eco/code-of-conduct";

export const INSTAGRAM_LINK = "https://www.instagram.com/klim.eco/";
export const LINKEDIN_LINK = "https://www.linkedin.com/company/klimeco/";

export const WEBINAR_LINK_DE = "https://www.klim.eco/de/landwirte/webinare";
export const WEBINAR_LINK_GB = "https://www.klim.eco/en/farmers/webinars";
export const WEBINAR_LINK_PL = "https://www.klim.eco/pl/rolnicy/webinary";
export const WEBINAR_LINK_DEFAULT = "https://www.klim.eco/farmers/webinars";

export const CAREER_LINK_DE = "https://www.klim.eco/de/karriere";
export const CAREER_LINK_GB = "https://www.klim.eco/en/careers";
export const CAREER_LINK_PL = "https://www.klim.eco/pl/kariera";
export const CAREER_LINK_CZ = "https://www.klim.eco/cz/kariera";
export const CAREER_LINK_DEFAULT = "https://www.klim.eco/careers";

export const CONTACT_LINK_DE = "https://www.klim.eco/de/landwirte/kontakt";
export const CONTACT_LINK_GB = "https://www.klim.eco/en/farmers/contact";
export const CONTACT_LINK_PL = "https://www.klim.eco/pl/rolnicy/kontakt";
export const CONTACT_LINK_CZ = "https://www.klim.eco/cz/zemedelec/contact";
export const CONTACT_LINK_DEFAULT = "https://www.klim.eco/farmers/contact";

export const VERIFICATION_DOCUMENTS_PDF_URL = "https://klimpublic.s3.eu-central-1.amazonaws.com/Verifizierung_Dokumente_2026-10-29.pdf";
